import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import Swal from "sweetalert2"

import { withTranslation, WithTranslation, Trans } from 'react-i18next';
import { Input, InputGroup, InputGroupAddon, FormGroup, FormFeedback } from 'reactstrap';
import RegexLibrary from '../../utils/Regex';
import Modal from 'components/Common/Modal/Modal'

import HttpAuth from '../../services/http/Auth';

import StorageAuth from '../../services/storage/Auth';

import Notification from '../../components/Elements/Notification';
import AppPaths from 'permissions/roles/all/AppPaths';

import './LoginForm.scss'

const LoginForm: FunctionComponent = (props:any) => {
  const { t } = useTranslation();

  const [emailValue, setEmailValue] = useState('')
  const [emailIsValid, setEmailIsValid] = useState(true)
  const [emailFeedbackMessage, setEmailFeedbackMessage] = useState('')
  const [resetEmailValue, setResetEmailValue] = useState('')
  const [resetEmailIsValid, setResetEmailIsValid] = useState(true)
  const [resetEmailFeedbackMessage, setResetEmailFeedbackMessage] = useState('')
  const [passwordValue, setPasswordValue] = useState('')
  const [passwordIsValid, setPasswordIsValid] = useState(true)
  const [passwordFeedbackMessage, setPasswordFeedbackMessage] = useState('')
  const [rememberMeValue, setRememberMeValue] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [showModal, setShowModal] = useState(false)


  // const changeLanguage = (lng: string) => {
  //   i18n.changeLanguage(lng);
  // }

  const validateResetEmail = () => {
    let isValid         = true;
    let feedbackMessage = '';

    if (!resetEmailValue) {
      isValid         = false;
      feedbackMessage = t('common.not-empty');
    } else if (!RegexLibrary.email.test(resetEmailValue)) {
      isValid         = false;
      feedbackMessage = t('common.email-format');
    }

    setResetEmailIsValid(isValid);
    setResetEmailFeedbackMessage(feedbackMessage);

    return isValid;
  }

  const validateEmail = () => {
    let isValid         = true;
    let feedbackMessage = '';

    if (!emailValue) {
      isValid         = false;
      feedbackMessage = t('common.not-empty');
    } else if (!RegexLibrary.email.test(emailValue)) {
      isValid         = false;
      feedbackMessage = t('common.email-format');
    }

    setEmailIsValid(isValid);
    setEmailFeedbackMessage(feedbackMessage);

    return isValid;
  }

  const validatePassword = () => {    
    let isValid         = true;
    let feedbackMessage = '';

    if (!passwordValue) {
      isValid         = false;
      feedbackMessage = t('common.not-empty');
    }
    setPasswordIsValid(isValid);
    setPasswordFeedbackMessage(feedbackMessage);

    return isValid;
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!validateEmail() || !validatePassword()) {
      return;
    }
    setLoading(true);

    let response;
    
    try {
      response = await new HttpAuth().login(emailValue, passwordValue);
    } catch (err) {
      Notification.displayException(err);
      setLoading(false);
      return;
    }
    
    setLoading(false);
    StorageAuth.saveSession(response.idToken, response.refreshToken, response.expiresIn, rememberMeValue, response.role, response.id);

    window.location.reload(); // NEEDED to change role
  }

  const handleModal = async () => {
    if (!validateResetEmail()) {
      return;
    }
    
    setLoadingModal(true);
    try {
      await new HttpAuth().resetPassword(resetEmailValue)
                          .then(() => {
                            Swal.fire({
                              title: t('alert.success.reset-password.title'),
                              text: t('alert.success.reset-password.text'),
                              icon: 'success',
                              showCancelButton: false
                            })
                          })
                          .catch((err) => setResetEmailFeedbackMessage((err as Error).message))
                          .finally(() => setShowModal(false))
    } catch (err) {
      setResetEmailFeedbackMessage((err as Error).message);
      setLoadingModal(false);
    }
  }

  return (
    <>
      <div id="login-form">
        <h1 className="section-title">
          <img className='img-fluid' src='../img/logo-login.png' alt='logo' />							
        </h1>
        <div id="form-container">
          <div className="col-md-12">
            <form onSubmit={handleSubmit}>
              <FormGroup>
                <InputGroup className="mb-2">
                  <InputGroupAddon addonType="prepend"><span className="input-group-text fas fa-at"></span></InputGroupAddon>
                  <Input type="text" placeholder="E-mail" autoFocus={true} invalid={!emailIsValid} value={emailValue} onChange={(e: any) => setEmailValue(e.target.value)} />
                  <FormFeedback>{ emailFeedbackMessage }</FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="mb-2">
                  <InputGroupAddon addonType="prepend"><span className="input-group-text fas fa-lock"></span></InputGroupAddon>
                  <Input type="password" placeholder="Password" invalid={!passwordIsValid} value={passwordValue} onChange={(e: any) => setPasswordValue(e.target.value)} />
                  <FormFeedback>{ passwordFeedbackMessage }</FormFeedback>
                </InputGroup>
              </FormGroup>
              <div className="col-md-12 mb-2 cursor-pointer">
                <small onClick={() => setShowModal(true)} ><Trans i18nKey="common.forgot-password" /></small>
              </div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-8 remember-me-container">
                    <div className="checkbox c-checkbox">
                      <label>
                        <Input checked={rememberMeValue} onChange={(e: any) => setRememberMeValue(e.target.checked)} type="checkbox"/>
                        <span className="fa fa-check"></span>&nbsp;<Trans i18nKey="pages.login.remember" />
                      </label>
                    </div>
                  </div>
                  <div className="col submit-container">
                    <button type="submit" className="btn btn-primary mb-2" disabled={loading} >
                      <Trans i18nKey="common.forms.submit" />
                      { loading &&
                        <i className='fa fa-spinner fa-spin ml-3'></i>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal 
        modal={showModal} 
        setModal={setShowModal} 
        className='page-selector-modal' 
        scrollable 
        createText={t('common.reset-password')} 
        handleSubmit={handleModal} 
        title={t('common.forgot-password')}
        noCancel
        size='md'
      >
        <div className="modal-container">
          <div className="col-12 text-center">
            <h4>{t('common.title-reset-password')}</h4>
          </div>
          <div className="col-12">
            <Input type="text" placeholder="E-mail" autoFocus={true} invalid={!resetEmailIsValid} value={resetEmailValue} onChange={(e: any) => setResetEmailValue(e.target.value)} />
            <FormFeedback>{ resetEmailFeedbackMessage }</FormFeedback>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default LoginForm;
